import { _environment } from './_environment.common';


export const environment = {
    ..._environment,
    production: false,
};
